<template>
  <div class="login-container">
    <div id="canvas-container"></div>
    <div :style="{'visibility': !showLogin ? 'hidden' : 'visible'}">
      <el-form
        v-show="showForm"
        autoComplete="on"
        :model="loginForm"
        :rules="loginRules"
        ref="loginForm"
        label-position="left"
        label-width="0px"
        class="card-box login-form"
      >
        <h3 class="title">共享单车监管平台</h3>
        <el-form-item prop="email">
          <el-input
            name="usernameOrPhone"
            type="text"
            v-model="loginForm.usernameOrPhone"
            autoComplete="on"
            placeholder="用户名"
          ></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            name="password"
            type="password"
            @keyup.enter.native="handleLogin"
            v-model="loginForm.password"
            autoComplete="on"
            placeholder="密码"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            style="width: 100%;background-color: #00DADA;border-color: #3e7878;"
            :loading="loading"
            @click.native.prevent="handleLogin"
          >
            登录
          </el-button>
        </el-form-item>
      </el-form>
      <el-form v-show="!showForm"
               autoComplete="on"
               :model="editLoginForm"
               :rules="editLoginRules"
               ref="editLoginForm"
               label-position="left"
               label-width="0px"
               class="card-box login-form">
        <div class="warn-title">{{resetPwdFlag?'您已重置密码':'您是第一次登录'}},为了您的帐号安全,请修改密码!</div>
        <h3 class="title">共享单车监管平台</h3>
        <el-form-item prop="oldPwd">
          <el-input
            name="oldPwd"
            type="password"
            v-model="editLoginForm.oldPwd"
            autoComplete="on"
            placeholder="原密码"
          ></el-input>
        </el-form-item>
        <el-form-item prop="newPwd">
          <el-input
            name="newPwd"
            type="password"
            @keyup.enter.native="handleEditPwd"
            v-model="editLoginForm.newPwd"
            autoComplete="on"
            placeholder="新密码"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            style="width: 100%"
            :loading="editLoading"
            @click.native.prevent="handleEditPwd">
            登录
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <div
      v-if="!showLogin"
      v-loading="!showLogin"
      element-loading-text="登录中..."
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
      style="height:100%;">
    </div>
    <div class="copyright" @click="toWeb">
      Copyright © 2020 gxdcjg.com 浙ICP备19047427号-2
    </div>
  </div>
</template>

<script>
import Api from '../../api'
import store from '../../store'
import CryptoJS from 'crypto-js'
export default {
  name: 'login',
  data() {
    const validateEmail = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入用户名'))
      } else {
        callback()
      }
    }
    const validatePass = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error('密码不能小于6位'))
      } else {
        callback()
      }
    }
    return {
      loginForm: {
        usernameOrPhone: '',
        password: '',
        operationDevice: ''
      },
      loginRules: {
        usernameOrPhone: [
          { required: true, trigger: 'blur', validator: validateEmail }
        ],
        password: [
          { required: true, trigger: 'blur', validator: validatePass }
        ]
      },
      editLoginForm: {
        oldPwd: '',
        newPwd: ''
      },
      editLoginRules: {
        oldPwd: [
          { required: true, trigger: 'blur', validator: this.validateOldPwd }
        ],
        newPwd: [
          { required: true, trigger: 'blur', validator: this.validateNewPwd }
        ]
      },
      loading: false,
      showDialog: false,
      showLogin: true,
      showForm: true,
      editLoading: false,
      device: '', // 用户登录设备
      resetPwdFlag: false // 重置密码标识
    }
  },
  methods: {
    autoLogin() {
      // 线上访问地址：https://www.gxdcjg.com/#/login?username=111&password=222
      // 测试访问地址：https://test1.gxdcjg.cn/gxdc/#/login?username=111&password=222
      const params = this.getAllUrlParam()
      this.loginForm.usernameOrPhone = params.username
      this.loginForm.password = params.password
      this.handleLogin()
    },
    getAllUrlParam(url) {
      url = !url ? window.location.href : url
      url = url.indexOf('?') > -1 ? url.substring(url.indexOf('?') + 1, url.length) : ''
      var result = {}
      if (url) {
        const list = url.toString().split('&')
        for (const obj of list) {
          result[obj.split('=')[0]] = obj.split('=')[1]
        }
      }
      return result
    },
    toWeb() {
      window.open('https://beian.miit.gov.cn/')
    },
    handleLogin() {
      const vm = this
      vm.$refs.loginForm.validate((valid) => {
        if (valid) {
          const password = this.encryptByAES(vm.loginForm.password)
          const username = this.encryptByAES(vm.loginForm.usernameOrPhone)
          const params = {
            usernameOrPhone: username,
            password: password
          }
          Api.getLoginLogListByUserId(params).then((res) => {
            if (res.code === 200) {
              if (res.data.userLoginLogList.length === 0) {
                // 用户第一次登录需修改密码
                vm.editLoginForm.oldPwd = vm.loginForm.password
                vm.showForm = false
              } else {
                const phone = res.data.user.phone
                // 判断该账号密码是否已重置，已重置则修改密码
                if (vm.loginForm.password === phone.slice(-6)) {
                  vm.showForm = false
                  vm.resetPwdFlag = true
                  vm.editLoginForm.oldPwd = vm.loginForm.password
                } else {
                  vm.loading = true
                  vm.loginForm.operationDevice = this.getLoginDevice()
                  Api.login(vm.loginForm)
                    .then((res) => {
                      if (res.code === 200 && res.data.token) {
                        this.publicLoginEvent(vm, res)
                      } else {
                        vm.initShowLogin()
                        vm.$message.error(res.message)
                      }
                      vm.loading = false
                    })
                    .catch((err) => {
                      vm.initShowLogin()
                      console.log('the login has problem! ', err)
                    })
                }
              }
            } else {
              vm.$message.warning(res.message)
              console.log('根据用户编号查询用户登录日志异常！', res.message)
            }
            console.log(res)
          }).catch((err) => {
            vm.$message.warning(err)
            console.log('根据用户编号查询用户登录登出日志数据异常！', err)
          })
        } else {
          console.log('error submit!!')
          vm.initShowLogin()
          return false
        }
      })
    },
    publicLoginEvent(vm, res) {
      const selfAreaId = res.data.areaId
      store.commit('globalVariable/setAreaId', selfAreaId)
      const authorizationParams = {
        key: 'authorization',
        value: `${res.data.tokenType} ${res.data.token}`
      }
      store
        .dispatch('user/login', authorizationParams)
        .then((res) => {
          const params = {
            selfAreaId
          }
          store
            .dispatch('user/getInfoByLogin', params)
            .then((response) => {
              const areaId =
                response && response.data && response.data.areaId
              let url = '/index/'
              if (areaId) {
                url += areaId
              }
              console.log(url, 111222)
              vm.$router.push(url)
            })
        })
    },
    initShowLogin() {
      if (!this.showLogin) {
        this.showLogin = true
        this.$router.push('/login')
        // this.loginForm.usernameOrPhone = ''
        // this.loginForm.password = ''
      }
    },
    handleEditPwd() {
      const vm = this
      vm.$refs.editLoginForm.validate((valid) => {
        if (valid) {
          const params = {
            selfAreaId: vm.selfAreaId
          }
          const data = {
            oldPwd: vm.editLoginForm.oldPwd,
            newPwd: vm.editLoginForm.newPwd,
            usernameOrPhone: vm.loginForm.usernameOrPhone,
            operationDevice: vm.getLoginDevice()
          }
          Api.updateFirstLoginPwd(data, params).then((res) => {
            if (res.code === 200) {
              this.publicLoginEvent(vm, res)
            } else {
              this.showForm = false
              this.$router.push('/login')
              vm.$message.warning(res.message)
            }
          })
        } else {
          this.showForm = false
          this.$router.push('/login')
          return false
        }
      })
    },
    validateOldPwd(rule, value, callback) {
      if (value === '') {
        callback(new Error('请输入原密码'))
      } else {
        callback()
      }
    },
    validateNewPwd(rule, value, callback) {
      if (value === '') {
        callback(new Error('请输入新密码'))
      } else
      if (!/^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[a-zA-Z0-9\W_]{8,}$/.test(value)) {
        callback(new Error('密码必须包含大写字母 、数字、 特殊字符（四种里至少三种，且至少8位）'))
      } else {
        callback()
      }
    },
    // AES算法加密密码函数
    encryptByAES(message) {
      // AES的秘钥长度为16字节
      const Key = '1qaz2wsx3edc4rfv'
      const keyHex = CryptoJS.enc.Utf8.parse(Key)
      const encrypted = CryptoJS.AES.encrypt(message, keyHex, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      })
      return encrypted.toString()
    }
  },
  mounted() {
    // let getRequestAnimId = bgAnimation();
    // this.$on("hook:destroyed", () =>
    //   window.cancelAnimationFrame(getRequestAnimId())
    // );
    if (location.href.indexOf('username=') > -1 && location.href.indexOf('password=') > -1) {
      this.showLogin = false
      this.autoLogin()
    }
  },
  created() {
    if (this.$store.state.user.needReload) {
      window.location.reload()
    }
  },
  components: {}
}
</script>

<style rel="stylesheet/scss" lang="less">
.copyright {
  color: #fff;
  font-size: 16px;
  position: absolute;
  bottom: 30px;
  left: 0;
  text-align: center;
  cursor: pointer;
  width: 100%;
  z-index: 10;
}
.tips {
  font-size: 14px;
  color: #fff;
  margin-bottom: 5px;
}

.login-container {
  position: relative;
  width: 100%;
  height: 100%;
  height: 100vh;
  background-color: #2d3a4b;
  input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0px 1000px #293444 inset !important;
    -webkit-text-fill-color: #fff !important;
  }
  input {
    background: transparent;
    border: 0px;
    -webkit-appearance: none;
    border-radius: 0px;
    padding: 12px 5px 12px 15px;
    color: #eeeeee;
    height: 47px;
  }
  .el-input {
    display: inline-block;
    height: 47px;
    width: 85%;
  }
  .svg-container {
    padding: 6px 5px 6px 15px;
    color: #889aa4;
  }
  .warn-title{
    text-align: center;
    margin-top: 40px;
    width: 84%;
    height: 30px;
    position: absolute;
    background-color: transparent;
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 3px;
    line-height: 30px;
    font-size: 13px;
    color: rgb(233 233 105);
  }
  .title {
    font-size: 26px;
    font-weight: 400;
    color: #eeeeee;
    margin: 0px auto 40px auto;
    text-align: center;
    font-weight: bold;
  }
  .login-form {
    position: absolute;
    left: 0;
    right: 0;
    width: 400px;
    padding: 35px 35px 15px 35px;
    margin: 120px auto;
    z-index: 2;
  }
  .el-form-item {
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    color: #454545;
  }
  .forget-pwd {
    color: #fff;
  }
}
#canvas-container {
  position: absolute;
  z-index: 1;
}
</style>
